import { Fragment } from "react/jsx-runtime";
import Physician from "../../../Physician/Models/Physician";
import { Col, Row } from "react-bootstrap";


interface IProps{
    physician: Physician;
}

export default function CCBlockSummaryAnnualFeesMeeting(props: IProps) {
    const nbsp = '\u00A0';
    var dueDate = new Date(props.physician.currentCCEnrollment.currentCCBlock.endDate);
    var blockPaid = props.physician.currentCCEnrollment.currentCCBlock.ccAnnualFees.every(_ => _.isPaid);

    const determineBlockYears = () => {
        var newBlockYears = new Array<number>();
        
        for (var year = props.physician.currentCCEnrollment.currentCCBlock.startYear; year <= props.physician.currentCCEnrollment.currentCCBlock.endYear; year++) {
            newBlockYears.push(year);
        }
        return newBlockYears;
    }

    var blockYears = determineBlockYears();

    const isPaid = (year: number) => {
        var annualFee = props.physician.currentCCEnrollment.currentCCBlock.ccAnnualFees.find(_ => _.year == year)

        if(annualFee != null){
            if (annualFee.isPaid) return true;
            if (annualFee.isWaived) return true;
    
            return false;
        }
    }

    return (
        <Fragment>
            <div className="ccenrollment-summary-padding">
                <div className="ccenrollment-summary-border" style={{background: '#fff'}}>
                    <Row className="ccenrollment-summary-cert">
                        <Col>
                            <Row className="ccenrollment-certificate-header">
                                <Col>
                                    <div className="mb-0 font-weight-bolder card-title pp-font-size-small text-center">Annual Fees</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {blockPaid == true ? 
                    <>
                        <Row>
                            <Col className="text-center">
                                <div className="text-success">
                                    <div className="las la-check-circle la-3x"></div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-success">
                                    <div className="pp-font-size-small text-center">
                                        <span>Annual Fee Payments Complete</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </>
                    :
                    <>
                        <Row>
                            <Col className="text-center">
                                <div className="las la-clock la-3x"></div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="pp-font-size-small text-center">
                                    <span>Due by {dueDate.getMonth()+1}/{dueDate.getDate()}/{dueDate.getFullYear()}</span>
                                </div>
                            </Col>
                        </Row>
                    </>
                }
                <Row>
                    <Col>
                        <div>
                            {nbsp}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="pr-md-0">
                        <div className="pp-font-size-smaller text-center">
                            <span><b>{blockYears[0]}</b></span>
                        </div>
                    </Col>
                    <Col className="px-md-0">
                        <div className="pp-font-size-smaller text-center">
                            <span><b>{blockYears[1]}</b></span>
                        </div>
                    </Col>
                    <Col className="pl-md-0">
                        <div className="pp-font-size-smaller text-center">
                            <span><b>{blockYears[2]}</b></span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="pr-md-0">
                        <div>
                            {isPaid(blockYears[0]) == true ? 
                                <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                :
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            }
                        </div>
                    </Col>
                    <Col className="px-md-0">
                        <div>
                            {isPaid(blockYears[1]) == true ? 
                                <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                :
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            }
                        </div>
                    </Col>
                    <Col className="pl-md-0">
                        <div>
                            {isPaid(blockYears[2]) == true ? 
                                <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                :
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            }
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="pp-font-size-smallest">
                            {nbsp}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="pp-font-size-smaller">
                            {nbsp}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </Fragment>
    );
}